module.exports = __webpack_public_path__ + "static/media/2020-09-01 21.55.46.8393d18e.jpg";